import ToolbarComponent from './Toolbar.vue';
export const Toolbar = ToolbarComponent;
export default Toolbar;
